import { Grid, Stack } from "@mui/material";
import { LoadedContent } from "components/common/loading/loadedContent";
import { useTenantTranslation } from "hooks/formatters";
import { useState } from "react";
import { ScrapChefUsageDetailedPoint } from "src/store/api/generatedApi";
import { TableHeader } from "../TableHeader";
import { ScrapChefUsageDetailedPlot } from "./ScrapChefUsageDetailedPlot";
import { ScrapChefUsageDetailedTable } from "./ScrapChefUsageDetailedTable";
import {
  ScrapChefUsageDetailedTabData,
  useStrategyDashboardScrapChefUsageDetailed,
} from "./scrapChefUsageDetailedHooks";

export const ScrapChefUsageDetailedView = () => {
  const data = useStrategyDashboardScrapChefUsageDetailed();
  return (
    <LoadedContent data={data}>
      {(data) => <ScrapChefUsageDetailedContent data={data} />}
    </LoadedContent>
  );
};

interface ContentProps {
  data: ScrapChefUsageDetailedTabData;
}

const ScrapChefUsageDetailedContent = ({ data }: ContentProps) => {
  const { t } = useTenantTranslation();

  const [selectedDate, setSelectedDate] = useState<Date | null>(() =>
    getDefaultSelectedDate(data.weekly)
  );

  return (
    <Stack pb={50}>
      <Grid container spacing={1} mt={2} mx={0}>
        <Grid size={{ xs: 8 }} ml={0}>
          <ScrapChefUsageDetailedPlot
            data={data.weekly}
            setSelectedDate={setSelectedDate}
          />
        </Grid>
        <Grid size={{ xs: 4 }}>
          <TableHeader
            titlePrefix={t("scrapChefUsageBreakdown")}
            subtitleText={t("scrapChefUsageDetailedTableSubtitleText")}
            selectedDate={selectedDate}
            formatDateMonthly={false}
          />
          <ScrapChefUsageDetailedTable
            data={data.weekly}
            selectedDate={selectedDate}
          />
        </Grid>
      </Grid>
    </Stack>
  );
};

const getDefaultSelectedDate = (
  data: ScrapChefUsageDetailedPoint[]
): Date | null => {
  const allDates = data
    .filter((d) => d.standard === "all")
    .map((d) => d.period_start)
    .sort();
  const latest = allDates[allDates.length - 1];
  return latest ? new Date(latest) : null;
};
